import Text from 'components/Text';
import styled from 'styled-components';

const EllipsisText = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export default EllipsisText;
